<script setup lang="ts">
defineProps<{
  compact?: boolean
}>()
</script>
<template>
  <a
    :href="
      createHotlineLink({
        text: 'Halo, saya tertarik dengan fitur KiriminAja'
      })
    "
    target="_blank"
    aria-label="Whatsapp Support"
    class="fixed z-95 text-white items-center bg-[#128c7e] shadow-xl rounded-full transform bottom-6 right-5"
  >
    <span
      :class="
        cn(
          'rounded-full overflow-hidden relative transition-all',
          'after:absolute after:rounded-full after:inset-0 after:shadow-[inset_0px_3px_3px_0px_rgba(220,248,198,0.28)]',
          'hover:before:scale-170 before:transition-all before:-translate-x-1/2 before:left-1/2 before:w-3/4 before:h-3/4 before:duration-300 before:-bottom-2 before:blur-md before:rounded-t-full before:bg-[#25d366] before:absolute',
          'p-2.5 group gap-2 flex',
          {
            'pr-5': compact,
            'p-1.5 border-none': !compact
          }
        )
      "
    >
      <Icon
        name="ic:outline-whatsapp"
        size="32px"
        class="group-hover:rotate-5 transition-all relative"
      />
      <span v-if="compact" class="grow grid relative">
        <span class="font-medium text-xs">Hubungi Kami</span>
        <span class="font-bold text-sm">via WhatsApp</span>
      </span>
    </span>
    <span
      :class="
        cn('absolute top-0 right-0 flex size-4 text-red-500', {
          'translate-y-0 translate-x-0 scale-70': !compact
        })
      "
    >
      <span
        class="absolute inline-flex h-full w-full animate-ping rounded-full bg-current opacity-75"
      ></span>
      <span class="relative inline-flex size-4 rounded-full bg-current"></span
    ></span>
  </a>
</template>
